import { useTranslation } from "react-i18next";

function Home() {
  const { t } = useTranslation();
  return (
    <main className="bg-background text-foreground flex min-h-screen items-center justify-center px-4">
      <div className="max-w-md text-center">
        <h1 className="text-foreground text-2xl font-semibold">{t("app.title")}</h1>
        <p className="text-muted-foreground mt-2 text-sm">{t("app.homeIntro")}</p>
      </div>
    </main>
  );
}

export default Home;
